<template>
    <div class="main">
        <img alt="Vue logo" class="image-holder2" src="../assets/forside-logo.png" />
        <div class="wrapper">
            <Parcel v-on:submitting="submitting=true" :parcel="parcel" :closed="closed" ref="parcelForm" />
        </div>

    </div>


</template>


<script>
    import Parcel from "../components/Step1.vue";
    import {SignerService} from "../services/SignerService";

    export default {
        name: "Home",
        components: {
            Parcel
        },
         data() {


            return {
                submitting: false,
                parcel: null,
                closed:false
            };
        },
        methods:{
            submit(){
                this.$refs.parcelForm.submit();
            }
        },
      async  created() {

            let urlParams = new URLSearchParams(window.location.search);
            let id = urlParams.get('id');
            this.closed = urlParams.get('closed')==='true';
            const result = await SignerService.getParcelInfo({
                id
            });
          if (result.status===200) {
              if ( result.data.statusCode==200 )
              {
                  this.parcel=result.data;
              }
              else if (result.data.statusCode==411)
              {
                  this.$swal({
                      icon: 'error',
                      title: 'Din pakke kan ikke valideres',
                      footer: '',
                      confirmButtonColor: '#FFD100',
                      iconColor:'#da202a',
                      html:
                          '<p class="p">' +
                          'Det er desværre ikke muligt, at oprette en engangsfuldmagt – det kan være af følgende årsager:' +
                          '</p>' +
                          '<p></p>' +
                          '<li class="p">Pakken er allerede på vej til dig *</li>' +
                          '<li class="p">Pakken er bestilt til en GLS PakkeShop</li>' +
                          '<li class="p">Pakken er bestilt til afhentning i en butik (Click&Collect)</li>' +
                          '<li class="p">Din afsender har ved pakkens afsendelse valgt, at pakken må stilles.</li>' +
                          '<li class="p">Pakken er en returpakke.</li>' +

                          '<p class="p">' +
                          '* Er din pakke på vej til dig kan du med fordel udstede en engangsfuldmagt på et stykke papir med angivelse af dit navn, pakkenummer, dato og din underskrift. Fuldmagten placeres på ydersiden af din hoveddør.' +
                          '</p>' +
                          '<p class="p">Læs mere her <a href="https://gls-group.eu/DK/da/fuldmagt">https://gls-group.eu/DK/da/fuldmagt.</a></p>'

                  });
              }
          }


        }
    };

</script>

<style lang="scss" scoped>
    #app {
        font-family: "NewsonGLS-Regular", Verdana, sans-serif;

    }
    .wrapper{
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 0px 0px 10px 10px;
        @media screen and(min-width:800px) {
            width: 100%;
            display: flex;
            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }
    .main {
        max-width: 800px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .image-holder2{
            border-radius: 10px 10px 0px 0px;
            width:800px;
            @media screen and (max-width: 800px) {
                width:100%;
            }
        }

        .logo {
            max-width: 200px;

            display: flex;
            flex-direction: column;
            @media screen and(max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and(max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: 600/19.2 * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>
